import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout } from '../../utils/metaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
  trackCheckout?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  href,
  trackCheckout = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy-900';
  const variants = {
    primary: 'bg-gold-500 hover:bg-gold-400 text-navy-900 shadow-lg shadow-gold-500/20',
    secondary: 'bg-transparent border-2 border-gold-500 text-gold-500 hover:bg-gold-500/10'
  };
  const classes = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const handleClick = (e: React.MouseEvent) => {
    if (trackCheckout) {
      trackInitiateCheckout();
    }
    if (props.onClick) {
      props.onClick(e as any);
    }
  };
  if (href) {
    return <motion.a href={href} onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-243">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} {...props} onClick={handleClick} data-id="element-244">
      {children}
    </motion.button>;
}